webpackJsonp([0],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/aBrightFutureForKids.8b68e71.jpg";

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/hondurasMinistries.94e0891.jpg";

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/mustardSeed.12297be.jpg";

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/velvetAshes.3f5a896.jpg";

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Landing__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Landing___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Landing__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Projects__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Projects___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Projects__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Contact__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Contact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_Contact__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Mission__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Mission___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_Mission__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Donate__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Donate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_Donate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_projects_FindingHome__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_projects_FindingHome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_projects_FindingHome__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_projects_HondurasMinistries__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_projects_HondurasMinistries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_projects_HondurasMinistries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_projects_MustardSeed__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_projects_MustardSeed___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_projects_MustardSeed__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_projects_VelvetAshes__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_projects_VelvetAshes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_projects_VelvetAshes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_projects_FlyingTreasure__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_projects_FlyingTreasure___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_projects_FlyingTreasure__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_projects_ABrightFutureForKids__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_projects_ABrightFutureForKids___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_projects_ABrightFutureForKids__);














__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{
    path: '/',
    name: 'Landing',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Landing___default.a
  }, {
    path: '/projects',
    name: 'Projects',
    component: __WEBPACK_IMPORTED_MODULE_3__components_Projects___default.a
  }, {
    path: '/contact',
    name: 'Contact',
    component: __WEBPACK_IMPORTED_MODULE_4__components_Contact___default.a
  }, {
    path: '/mission',
    name: 'Mission',
    component: __WEBPACK_IMPORTED_MODULE_5__components_Mission___default.a
  }, {
    path: '/donate',
    name: 'Donate',
    component: __WEBPACK_IMPORTED_MODULE_6__components_Donate___default.a
  }, {
    path: '/projects/honduras-ministries',
    name: 'hondurasMinistries',
    component: __WEBPACK_IMPORTED_MODULE_8__components_projects_HondurasMinistries___default.a
  }, {
    path: '/projects/mustard-seed',
    name: 'mustardSeed',
    component: __WEBPACK_IMPORTED_MODULE_9__components_projects_MustardSeed___default.a
  }, {
    path: '/projects/velvet-ashes',
    name: 'velvetAshes',
    component: __WEBPACK_IMPORTED_MODULE_10__components_projects_VelvetAshes___default.a
  }, {
    path: '/projects/a-bright-future-for-kids',
    name: 'aBrightFutureForKids',
    component: __WEBPACK_IMPORTED_MODULE_12__components_projects_ABrightFutureForKids___default.a
  }, {
    path: '*',
    name: '404',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Landing___default.a
  }]
}));

/***/ }),
/* 10 */,
/* 11 */,
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(14),
  /* template */
  __webpack_require__(81),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 13 */,
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Navigation__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Navigation___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Navigation__);



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  components: { Navigation: __WEBPACK_IMPORTED_MODULE_0__components_Navigation___default.a }
});

/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'contact',
  data: function data() {
    return {
      menuType: 'light'
    };
  },
  beforeMount: function beforeMount() {
    this.$store.commit('setMenuType', this.menuType);
  },
  mounted: function mounted() {
    $(function () {
      var form = $('#ajax-contact');
      var formMessages = $('#form-messages');

      $(form).submit(function (event) {
        event.preventDefault();
        var formData = $(form).serialize();
        $.ajax({
          type: 'POST',
          url: $(form).attr('action'),
          data: formData
        }).done(function (response) {
          $(formMessages).removeClass('form__error');
          $(formMessages).addClass('form__success');

          $(formMessages).text(response);

          $('#name').val('');
          $('#email').val('');
          $('#message').val('');
        }).fail(function (data) {
          $(formMessages).removeClass('success');
          $(formMessages).addClass('error');

          if (data.responseText !== '') {
            $(formMessages).text(data.responseText);
          } else {
            $(formMessages).text('Oops! An error occured and your message could not be sent.');
          }
        });
      });
    });
  }
});

/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'donate',
  data: function data() {
    return {
      menuType: 'light'
    };
  },
  beforeMount: function beforeMount() {
    this.$store.commit('setMenuType', this.menuType);
  }
});

/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'landing',
  data: function data() {
    return {
      heading: "Let's Make God Famous",
      copy: "We make the true, living God famous through creative use of film and digital media.",
      cta: "View Our Projects",
      menuType: 'light'
    };
  },
  beforeMount: function beforeMount() {
    this.$store.commit('setMenuType', this.menuType);
  }
});

/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'mission',
  data: function data() {
    return {
      menuType: 'dark'
    };
  }
});

/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'navigation',
  data: function data() {
    return {
      isOpen: false,
      pageName: 'Home',
      darkMenu: false,
      fixedMenu: false
    };
  },
  mounted: function mounted() {
    this.toggleMenuStyle(this.$route.path);
  },

  watch: {
    '$route': function $route(newRoute, oldRoute) {
      this.toggleMenuStyle(newRoute.path);
    }
  },
  methods: {
    toggleMenu: function toggleMenu() {
      if (this.isOpen) {
        this.isOpen = false;
      } else {
        this.isOpen = true;
      }
    },
    toggleMenuStyle: function toggleMenuStyle(route) {
      switch (route) {
        case '/':
          this.pageName = 'Home';
          this.darkMenu = false;
          this.fixedMenu = true;
          break;
        case '/projects':
          this.pageName = 'Projects';
          this.darkMenu = true;
          this.fixedMenu = false;
          break;
        case '/mission':
          this.pageName = 'Mission';
          this.darkMenu = true;
          this.fixedMenu = false;
          break;
        case '/donate':
          this.pageName = 'Donate';
          this.darkMenu = false;
          this.fixedMenu = false;
          break;
        case '/contact':
          this.pageName = 'Contact';
          this.darkMenu = false;
          this.fixedMenu = false;
          break;
        default:
          this.pageName = 'Projects';
          this.darkMenu = false;
          this.fixedMenu = false;
          break;
      }
    }
  }
});

/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'projects',
  data: function data() {
    return {
      menuType: 'dark'
    };
  },
  mounted: function mounted() {
    var _this = this;

    var container = $('#js__projects__container');
    var leftArrow = $('#js__projects__arrow__left');
    var rightArrow = $('#js__projects__arrow__right');

    this.checkWidth(container, leftArrow, rightArrow);

    console.log(container.width());

    container.scroll(function () {
      _this.checkWidth(container, leftArrow, rightArrow);
    });

    $(window).resize(function () {
      _this.checkWidth(container, leftArrow, rightArrow);
    });

    rightArrow.click(function () {
      container.animate({
        scrollLeft: container.scrollLeft() + $('.fk__projects__project').width()
      }, 250);
    });

    leftArrow.click(function () {
      container.animate({
        scrollLeft: container.scrollLeft() - $('.fk__projects__project').width()
      }, 250);
    });
  },

  methods: {
    checkWidth: function checkWidth(container, leftArrow, rightArrow) {
      var project = $('.fk__projects__project');

      if ($(window).width() >= 768) {
        if (container.scrollLeft() === 0) {
          leftArrow.hide();
        } else {
          leftArrow.show();
        }

        if (container.width() + container.scrollLeft() > project.length * project.width() + 128) {
          rightArrow.hide();
        } else {
          rightArrow.show();
        }
      } else {
        leftArrow.hide();
        rightArrow.hide();
      }
    }
  }
});

/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fitvids__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fitvids___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_fitvids__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'project',
  data: function data() {
    return {
      menuType: 'dark',
      videos: [{
        name: 'A Bright Future for Kids',
        link: 'https://player.vimeo.com/video/228287489',
        active: true
      }, {
        name: 'A Bright Future for Kids - Momma Daniel',
        link: 'https://player.vimeo.com/video/218064524',
        active: false
      }, {
        name: 'A Bright Future for Kids - Grandma Ester',
        link: 'https://player.vimeo.com/video/228283874',
        active: false
      }, {
        name: 'A Bright Future for Kids - Momma Rose',
        link: 'https://player.vimeo.com/video/228286126',
        active: false
      }]
    };
  },
  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_0_fitvids___default()('.js__fitvids');
  }
});

/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fitvids__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fitvids___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_fitvids__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'project',
  data: function data() {
    return {
      menuType: 'dark',
      videos: [{
        name: 'Finding Home Trailer',
        link: 'https://player.vimeo.com/video/87199168',
        active: true
      }, {
        name: 'Finding Home - Papa Joe',
        link: 'https://player.vimeo.com/video/92892302',
        active: false
      }, {
        name: 'Finding Home - Kid’s Casinos',
        link: 'https://player.vimeo.com/video/92744492',
        active: false
      }]
    };
  },
  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_0_fitvids___default()('.js__fitvids');
  }
});

/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fitvids__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fitvids___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_fitvids__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'project',
  data: function data() {
    return {
      menuType: 'dark',
      videos: [{
        name: 'CIY - Aullido - Short Narrative Film',
        credit: 'Trailer and Film Edit',
        link: 'https://player.vimeo.com/video/128621690',
        active: true
      }, {
        name: 'Christ in Youth - Ruby - Short Documentary Film',
        link: 'https://player.vimeo.com/video/98465957',
        credit: 'Trailer and Film Edit',
        active: false
      }, {
        name: 'Christ in Youth - Unseen - Short Narrative Film',
        link: 'https://player.vimeo.com/video/219902386',
        credit: 'Credit - Film Edit',
        active: false
      }, {
        name: 'First Church Verdigris - Promotional',
        link: 'https://player.vimeo.com/video/138999597',
        credit: 'Credit - Creator',
        active: false
      }, {
        name: 'First Church - Wes - Testimony',
        link: 'https://player.vimeo.com/video/124335519',
        credit: 'Credit - Creator',
        active: false
      }]
    };
  },
  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_0_fitvids___default()('.js__fitvids');
  }
});

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fitvids__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fitvids___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_fitvids__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'project',
  data: function data() {
    return {
      menuType: 'dark',
      videos: [{
        name: 'Honduras Ministries: Lucidalia’s Story',
        link: 'https://player.vimeo.com/video/170888948',
        active: true
      }]
    };
  },
  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_0_fitvids___default()('.js__fitvids');
  }
});

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fitvids__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fitvids___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_fitvids__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'project',
  data: function data() {
    return {
      menuType: 'dark',
      videos: [{
        name: 'Mustard Seed Network Promotional',
        link: 'https://player.vimeo.com/video/221628499',
        active: true
      }, {
        name: 'Mustard Seed Network Kobe',
        link: 'https://player.vimeo.com/video/221638245',
        active: false
      }, {
        name: 'Mustard Seed Network Nagoya',
        link: 'https://player.vimeo.com/video/228287118',
        active: false
      }, {
        name: 'Mustard Seed Network Osaka',
        link: 'https://player.vimeo.com/video/228287249',
        active: false
      }, {
        name: 'Mustard Seed Network Kyoto',
        link: 'https://player.vimeo.com/video/230452612',
        active: true
      }, {
        name: 'Mustard Seed - Osaka Building',
        link: 'https://player.vimeo.com/video/231712916',
        active: true
      }]
    };
  },
  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_0_fitvids___default()('.js__fitvids');
  }
});

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fitvids__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fitvids___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_fitvids__);




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'project',
  data: function data() {
    return {
      menuType: 'dark',
      videos: [{
        name: 'Velvet Ashes 2017 Retreat Promo',
        link: 'https://player.vimeo.com/video/218060178',
        active: true
      }, {
        name: 'Velvet Ashes Donation Promo',
        link: 'https://player.vimeo.com/video/218057383',
        active: false
      }, {
        name: 'Velvet Ashes - A Night at the Grove',
        link: 'https://player.vimeo.com/video/221778065',
        active: false
      }]
    };
  },
  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_0_fitvids___default()('.js__fitvids');
  }
});

/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_es6_promise__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_es6_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_es6_promise__);






__WEBPACK_IMPORTED_MODULE_4_es6_promise___default.a.polyfill();

global.jQuery = __webpack_require__(11);
var $ = global.jQuery;
window.$ = $;

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* default */]);
var store = new __WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* default */].Store({
  state: {
    menuType: ''
  },
  mutations: {
    setMenuType: function setMenuType(state, menuType) {
      state.menuType = menuType;
    }
  }
});

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  store: store,
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(2)))

/***/ }),
/* 28 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 29 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 30 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 31 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 32 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 33 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 34 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 35 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 36 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 37 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 38 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 39 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 40 */,
/* 41 */,
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/large-netflix.32b77bf.png";

/***/ }),
/* 43 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+CjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+Cjxzdmcgd2lkdGg9IjEwMCUiIGhlaWdodD0iMTAwJSIgdmlld0JveD0iMCAwIDYwMCA2MDAiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSIgc3R5bGU9ImZpbGwtcnVsZTpldmVub2RkO2NsaXAtcnVsZTpldmVub2RkO3N0cm9rZS1saW5lam9pbjpyb3VuZDtzdHJva2UtbWl0ZXJsaW1pdDoxLjQxNDIxOyI+CiAgICA8ZyB0cmFuc2Zvcm09Im1hdHJpeCgyMC40NzU2LDAsMCwyMC40NzU2LDI4LDI4KSI+CiAgICAgICAgPGNsaXBQYXRoIGlkPSJfY2xpcDEiPgogICAgICAgICAgICA8cGF0aCBkPSJNMTEuMDc1LDE1Ljk4NkwxMC44NDksMTkuMzczQzExLjE4MSwxOS4zNzMgMTEuMzI4LDE5LjIyMSAxMS41MTMsMTkuMDQxTDEzLjEwOCwxNy40ODlMMTYuNDI4LDE5Ljk0MkMxNy4wMzksMjAuMjc5IDE3LjQ4LDIwLjEwNCAxNy42MzIsMTkuMzc0TDE5LjgxMSw5LjEwNUMyMC4wMzQsOC4yMTEgMTkuNDcsNy44MDUgMTguODg2LDguMDcxTDYuMDksMTMuMDA1QzUuMjE2LDEzLjM1NSA1LjIyMSwxMy44NDIgNS45MzEsMTQuMDU5TDkuMjE0LDE1LjA4NEwxNi44MTcsMTAuMjg4QzE3LjE3NSwxMC4wNzEgMTcuNTA1LDEwLjE4OCAxNy4yMzQsMTAuNDI3TDExLjA3NSwxNS45ODZMMTEuMDc1LDE1Ljk4NlpNMTMuMjg0LDI2LjU2OEM1Ljk0NywyNi41NjggMCwyMC42MjEgMCwxMy4yODRDMCw1Ljk0OCA1Ljk0NywwIDEzLjI4NCwwQzIwLjYyMSwwIDI2LjU2OCw1Ljk0OCAyNi41NjgsMTMuMjg0QzI2LjU2OCwyMC42MjEgMjAuNjIxLDI2LjU2OCAxMy4yODQsMjYuNTY4WiIvPgogICAgICAgIDwvY2xpcFBhdGg+CiAgICAgICAgPGcgY2xpcC1wYXRoPSJ1cmwoI19jbGlwMSkiPgogICAgICAgICAgICA8cmVjdCB4PSItNSIgeT0iLTUiIHdpZHRoPSIzNi41NjgiIGhlaWdodD0iMzYuNTY4IiBzdHlsZT0iZmlsbDpyZ2IoOTEsNzUsNzMpO2ZpbGwtcnVsZTpub256ZXJvOyIvPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+Cg=="

/***/ }),
/* 44 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/findingHome.dccc1f3.jpg";

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/flyingTreasure.155191f.jpg";

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/aBrightFutureForKidsTestimonial.77ebe04.jpg";

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/flyingTreasureTestimonial.8db38f0.jpg";

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/hondurasMinistriesTestimonial.2094fe8.jpg";

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/mustardSeedTestimonial.917b7ff.jpg";

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/velvetAshesTestimonial.6944e65.jpg";

/***/ }),
/* 52 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 53 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 54 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/famousKingLogo.a099db1.jpg";

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/kent.96b337d.jpg";

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/missionFeature.b1a0f0e.jpg";

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(35)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(15),
  /* template */
  __webpack_require__(77),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(29)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(16),
  /* template */
  __webpack_require__(71),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(36)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(17),
  /* template */
  __webpack_require__(78),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(39)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(18),
  /* template */
  __webpack_require__(82),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(33)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(19),
  /* template */
  __webpack_require__(75),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(32)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(20),
  /* template */
  __webpack_require__(74),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(28)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(21),
  /* template */
  __webpack_require__(70),
  /* scopeId */
  "data-v-096f8c1a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(31)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(22),
  /* template */
  __webpack_require__(73),
  /* scopeId */
  "data-v-1f00ac7d",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(37)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(23),
  /* template */
  __webpack_require__(79),
  /* scopeId */
  "data-v-7156420e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(38)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(24),
  /* template */
  __webpack_require__(80),
  /* scopeId */
  "data-v-88c75238",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(30)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(25),
  /* template */
  __webpack_require__(72),
  /* scopeId */
  "data-v-133c2030",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(34)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(26),
  /* template */
  __webpack_require__(76),
  /* scopeId */
  "data-v-3a5a8e11",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "project fk__project"
  }, [_c('div', {
    staticClass: "bg"
  }), _vm._v(" "), _c('div', {
    staticClass: "cover"
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "fk__project__bottom"
  }, [_c('h2', {
    staticClass: "fk__heading fk__heading--dark fk__project__bottom__heading"
  }, [_vm._v("Videos")]), _vm._v(" "), _c('div', {
    staticClass: "fk__project__video-container"
  }, _vm._l((_vm.videos), function(video) {
    return _c('div', {
      staticClass: "fk__project__video"
    }, [_c('div', {
      staticClass: "js__fitvids"
    }, [_c('iframe', {
      attrs: {
        "src": video.link + '?title=0&byline=0&portrait=0',
        "frameborder": "0",
        "rameborder": "0",
        "webkitallowfullscreen": "",
        "mozallowfullscreen": "",
        "allowfullscreen": ""
      }
    })]), _vm._v(" "), _c('p', {
      staticClass: "fk__project__video__title"
    }, [_vm._v(_vm._s(video.name))])])
  }))]), _vm._v(" "), _vm._m(1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fk__project__top"
  }, [_c('div', {
    staticClass: "fk__project__top__image"
  }, [_c('img', {
    staticClass: "fk__project__top__image__img",
    attrs: {
      "src": __webpack_require__(5)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "fk__project__top__info"
  }, [_c('div', {
    staticClass: "fk__project__top__info__container"
  }, [_c('h2', {
    staticClass: "fk__project__top__info__title"
  }, [_vm._v("A Bright Future For Kids")]), _vm._v(" "), _c('p', {
    staticClass: "fk__project__top__info__year"
  }, [_vm._v("2016-2017")]), _vm._v(" "), _c('p', {
    staticClass: "fk__project__top__info__details"
  }, [_vm._v("Promotional")]), _vm._v(" "), _c('div', {
    staticClass: "fk__project__top__info__description"
  }, [_c('p', [_vm._v("A Bright Future for Kids targets the core causes of poverty by embracing a holistic approach for lasting transformation that secures a bright future for underprivileged communities.  Their outreach team in Ethiopia and in Kenya are currently working with families in an effort to change their current situations to provide pathways to success. This ranges from providing school supplies for kids to helping parents build a small business that will provide for their families through the small scale business venture.")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fk__project__testimonial"
  }, [_c('div', {
    staticClass: "fk__project__testimonial__person"
  }, [_c('div', {
    staticClass: "fk__project__testimonial__person__info"
  }, [_c('img', {
    staticClass: "fk__project__testimonial__person__info--photo",
    attrs: {
      "src": __webpack_require__(47)
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "fk__project__testimonial__person__info--name"
  }, [_vm._v("Solomon Dabe")]), _vm._v(" "), _c('h3', {
    staticClass: "fk__project__testimonial__person__info--title"
  }, [_vm._v("Founder of A Bright Future For Kids")])])]), _vm._v(" "), _c('div', {
    staticClass: "fk__project__testimonial__quote"
  }, [_c('h3', {
    staticClass: "fk__project__testimonial__quote__heading"
  }, [_vm._v("Client Testimonial")]), _vm._v(" "), _c('p', {
    staticClass: "fk__project__testimonial__quote__copy"
  }, [_vm._v("Traveling with Derek was more than filming; for me it was being sent to do kingdom work along side a brother in Christ.  During the whole video production process Derek took much time to have lengthy discussions on not only the project for him to understand the whole story of the organization and to try to understand every detail.  Derek serves passionately, gives his everything, and performed excellent work for our organization that has been much needed.\n      "), _c('br'), _c('br'), _vm._v("The impact of the final videos has just begun for us, but I believe these videos that Famous King has provided for us will give a way of exposing the dark places in the areas we work and bring a powerful message.  God for sure crossed our paths for a reason.  I thank God and am grateful for Famous King to come along side of ABF4K.  We would not have been able to videos or videos of such quality otherwise.")])])])
}]}

/***/ }),
/* 71 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "donate fk__donate"
  }, [_c('div', {
    staticClass: "fk__donate__bg"
  }), _vm._v(" "), _c('div', {
    staticClass: "fk__donate__box"
  }, [_c('h2', {
    staticClass: "fk__heading fk__heading--light fk__donate__heading"
  }, [_vm._v("Make a Donation")]), _vm._v(" "), _c('p', {
    staticClass: "fk__donate__box__copy"
  }, [_vm._v("Famous King is beginning to make an impact and plans to focus full-time creative talent on the task of making God famous. Our goal is to raise over $100k in this first year of operation... we have $10k designated as matching funds already committed to this campaign.")]), _vm._v(" "), _c('p', {
    staticClass: "fk__donate__box__copy"
  }, [_vm._v("Famous King is just getting started. We are excited about our current partners and are eager to see how God's story continues through them. Famous King needs your financial support in order to work on these projects with our partners in a cost effective manner.")]), _vm._v(" "), _c('p', {
    staticClass: "fk__donate__box__copy"
  }, [_vm._v("One such project is a short documentary with the Mustard Seed organization who can be found our project page. The short doc will focus on the importance of getting church leaders into Japan and church multiplication within Japan. Much of the project has already been shot but we still need help funding the post-production phase.")]), _vm._v(" "), _c('p', {
    staticClass: "fk__donate__box__copy"
  }, [_vm._v("Famous King is a fully qualified 501(c)(3) organization and therefore your donation is fully tax deductible.")])]), _vm._v(" "), _c('div', {
    staticClass: "fk__donate__box fk__donate__box--white"
  }, [_c('form', {
    staticClass: "fk__donate__form"
  }, [_c('iframe', {
    staticStyle: {
      "max-width": "500px",
      "min-width": "310px",
      "max-height": "none!important"
    },
    attrs: {
      "src": "https://donorbox.org/embed/new-beginnings-for-famous-king?recurring=true",
      "height": "685px",
      "width": "100%",
      "seamless": "seamless",
      "id": "dbox-form-embed",
      "name": "donorbox",
      "frameborder": "0",
      "scrolling": "no"
    }
  })])])])
}]}

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "project fk__project"
  }, [_c('div', {
    staticClass: "bg"
  }), _vm._v(" "), _c('div', {
    staticClass: "cover"
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "fk__project__bottom"
  }, [_c('h2', {
    staticClass: "fk__heading fk__heading--dark fk__project__bottom__heading"
  }, [_vm._v("Videos")]), _vm._v(" "), _c('div', {
    staticClass: "fk__project__video-container"
  }, _vm._l((_vm.videos), function(video) {
    return _c('div', {
      staticClass: "fk__project__video"
    }, [_c('div', {
      staticClass: "js__fitvids"
    }, [_c('iframe', {
      attrs: {
        "src": video.link + '?title=0&byline=0&portrait=0',
        "frameborder": "0",
        "rameborder": "0",
        "webkitallowfullscreen": "",
        "mozallowfullscreen": "",
        "allowfullscreen": ""
      }
    })]), _vm._v(" "), _c('p', {
      staticClass: "fk__project__video__title"
    }, [_vm._v(_vm._s(video.name))])])
  }))]), _vm._v(" "), _vm._m(1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fk__project__top"
  }, [_c('div', {
    staticClass: "fk__project__top__image"
  }, [_c('img', {
    staticClass: "fk__project__top__image__img",
    attrs: {
      "src": __webpack_require__(7)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "fk__project__top__info"
  }, [_c('div', {
    staticClass: "fk__project__top__info__container"
  }, [_c('h2', {
    staticClass: "fk__project__top__info__title"
  }, [_vm._v("Mustard Seed Network")]), _vm._v(" "), _c('p', {
    staticClass: "fk__project__top__info__year"
  }, [_vm._v("2017")]), _vm._v(" "), _c('p', {
    staticClass: "fk__project__top__info__details"
  }, [_vm._v("Promotional")]), _vm._v(" "), _c('div', {
    staticClass: "fk__project__top__info__description"
  }, [_c('p', [_vm._v("Mustard Seed Network exists to glorify God by making disciples through planting gospel-centered churches in urban Japan.    To see the cities of Japan saturated with and impacted by gospel-centered churches that further the global cause of Jesus Christ.  Their goal is to recruit and train church planters, catalyze church plants, and support church planters and church plants.")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fk__project__testimonial"
  }, [_c('div', {
    staticClass: "fk__project__testimonial__person"
  }, [_c('div', {
    staticClass: "fk__project__testimonial__person__info"
  }, [_c('img', {
    staticClass: "fk__project__testimonial__person__info--photo",
    attrs: {
      "src": __webpack_require__(50)
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "fk__project__testimonial__person__info--name"
  }, [_vm._v("Jay Greer")]), _vm._v(" "), _c('h3', {
    staticClass: "fk__project__testimonial__person__info--title"
  }, [_vm._v("Pastor at Mustard Seed Christian Church Osaka")]), _vm._v(" "), _c('h3', {
    staticClass: "fk__project__testimonial__person__info--title"
  }, [_vm._v("President of Mustard Seed Network")])])]), _vm._v(" "), _c('div', {
    staticClass: "fk__project__testimonial__quote"
  }, [_c('h3', {
    staticClass: "fk__project__testimonial__quote__heading"
  }, [_vm._v("Client Testimonial")]), _vm._v(" "), _c('p', {
    staticClass: "fk__project__testimonial__quote__copy"
  }, [_vm._v("Famous King has blessed our ministry with high-quality videos that we wouldn't have been able to afford without the amazing financial partnership program of Famous King. Having seen Derek's work in the past I knew we would get a fantastic, professional product. However, I was further impressed by the way Derek came and learned our ministry. He represented us, our vision, our values, and our mission in a way that captured the heart of what we do. We're thankful for the impact Famous King has made both in our target group in Japan and on our supporters around the world.")])])])
}]}

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "project fk__project"
  }, [_c('div', {
    staticClass: "bg"
  }), _vm._v(" "), _c('div', {
    staticClass: "cover"
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "fk__project__bottom"
  }, [_c('h2', {
    staticClass: "fk__heading fk__heading--dark fk__project__bottom__heading"
  }, [_vm._v("Videos")]), _vm._v(" "), _c('div', {
    staticClass: "fk__project__video-container"
  }, _vm._l((_vm.videos), function(video) {
    return _c('div', {
      staticClass: "fk__project__video"
    }, [_c('div', {
      staticClass: "js__fitvids"
    }, [_c('iframe', {
      attrs: {
        "src": video.link + '?title=0&byline=0&portrait=0',
        "frameborder": "0",
        "rameborder": "0",
        "webkitallowfullscreen": "",
        "mozallowfullscreen": "",
        "allowfullscreen": ""
      }
    })]), _vm._v(" "), _c('p', {
      staticClass: "fk__project__video__title"
    }, [_vm._v(_vm._s(video.name))])])
  }))]), _vm._v(" "), _vm._m(1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fk__project__top"
  }, [_c('div', {
    staticClass: "fk__project__top__image"
  }, [_c('img', {
    staticClass: "fk__project__top__image__img",
    attrs: {
      "src": __webpack_require__(45)
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "fk__project__top__netflix",
    attrs: {
      "href": "https://www.netflix.com/title/80109146"
    }
  }, [_c('img', {
    staticClass: "fk__project__top__netflix__image",
    attrs: {
      "src": __webpack_require__(44)
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "fk__project__top__info"
  }, [_c('div', {
    staticClass: "fk__project__top__info__container"
  }, [_c('h2', {
    staticClass: "fk__project__top__info__title"
  }, [_vm._v("Finding Home")]), _vm._v(" "), _c('p', {
    staticClass: "fk__project__top__info__year"
  }, [_vm._v("2014")]), _vm._v(" "), _c('p', {
    staticClass: "fk__project__top__info__details"
  }, [_vm._v("Full Length Documentary / Rapha House")]), _vm._v(" "), _c('div', {
    staticClass: "fk__project__top__info__description"
  }, [_c('p', [_vm._v("No child deserves to be trafficked. No child deserves to be sexually exploited. Rapha House’s vision is to see children living safely in communities without the threats of trafficking and sexual exploitation.")]), _vm._v(" "), _c('p', [_vm._v("Finding Home is a gripping documentary following the lives of three young Cambodian women who were victims of sex trafficking at a young age. Through three years of filming their post trafficking experiences, the film allows these young women to reveal their stories with dignity. The viewer will see the devastation and heartache of these tragic stories, but will also experience hope and joy as they journey with these young women on a path from victim to survivor. Finding Home reminds us that we are all connected in our humanity; that we are all looking for a place of love, acceptance and community. A place called home.")]), _vm._v(" "), _c('p', [_vm._v("*This project was done under the name Flying Treasure which is creative lead Derek Hammeke's company.  The Rapha House organization plans to continue work with Famous King in the future.")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "https://www.netflix.com/title/80109146"
    }
  }, [_c('img', {
    staticClass: "fk__project__netflix-banner",
    attrs: {
      "src": __webpack_require__(42)
    }
  })])
}]}

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "projects fk__projects"
  }, [_c('div', {
    staticClass: "fk__projects__bg--texture"
  }), _vm._v(" "), _c('div', {
    staticClass: "fk__projects__bg--orange"
  }), _vm._v(" "), _c('div', {
    staticClass: "fk__projects__gradient"
  }), _vm._v(" "), _c('h2', {
    staticClass: "fk__heading fk__heading--dark fk__projects__heading"
  }, [_vm._v("Check Out Our Projects")]), _vm._v(" "), _c('div', {
    staticClass: "fk__projects__container",
    attrs: {
      "id": "js__projects__container"
    }
  }, [_c('router-link', {
    staticClass: "fk__projects__project",
    attrs: {
      "to": "/projects/mustard-seed"
    }
  }, [_c('img', {
    staticClass: "fk__projects__project__poster",
    attrs: {
      "src": __webpack_require__(7)
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "fk__projects__project__title"
  }, [_vm._v("Mustard Seed")])]), _vm._v(" "), _c('router-link', {
    staticClass: "fk__projects__project",
    attrs: {
      "to": "/projects/honduras-ministries"
    }
  }, [_c('img', {
    staticClass: "fk__projects__project__poster",
    attrs: {
      "src": __webpack_require__(6)
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "fk__projects__project__title"
  }, [_vm._v("Honduras Ministries")])]), _vm._v(" "), _c('router-link', {
    staticClass: "fk__projects__project",
    attrs: {
      "to": "/projects/a-bright-future-for-kids"
    }
  }, [_c('img', {
    staticClass: "fk__projects__project__poster",
    attrs: {
      "src": __webpack_require__(5)
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "fk__projects__project__title"
  }, [_vm._v("A Bright Future For Kids")])]), _vm._v(" "), _c('router-link', {
    staticClass: "fk__projects__project",
    attrs: {
      "to": "/projects/velvet-ashes"
    }
  }, [_c('img', {
    staticClass: "fk__projects__project__poster",
    attrs: {
      "src": __webpack_require__(8)
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "fk__projects__project__title"
  }, [_vm._v("Velvet Ashes")])]), _vm._v(" "), _c('div', {
    staticClass: "fk__projects__arrow fk__projects__arrow--left",
    attrs: {
      "id": "js__projects__arrow__left"
    }
  }, [_c('svg', {
    staticClass: "fk__projects__arrow__svg fk__projects__arrow__svg--left",
    attrs: {
      "viewBox": "0 0 100 100",
      "xmlns": "http://www.w3.org/2000/svg",
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-miterlimit": "1.5"
    }
  }, [_c('path', {
    attrs: {
      "d": "M12.664 31.332L50 68.67 87.34 31.33",
      "fill": "none",
      "stroke": "#fff",
      "stroke-width": "16.38627"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "fk__projects__arrow fk__projects__arrow--right",
    attrs: {
      "id": "js__projects__arrow__right"
    }
  }, [_c('svg', {
    staticClass: "fk__projects__arrow__svg fk__projects__arrow__svg--right",
    attrs: {
      "viewBox": "0 0 100 100",
      "xmlns": "http://www.w3.org/2000/svg",
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-miterlimit": "1.5"
    }
  }, [_c('path', {
    attrs: {
      "d": "M12.664 31.332L50 68.67 87.34 31.33",
      "fill": "none",
      "stroke": "#fff",
      "stroke-width": "16.38627"
    }
  })])])], 1)])
},staticRenderFns: []}

/***/ }),
/* 75 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "navigation fk__navigation",
    class: {
      'fk__navigation--dark': _vm.darkMenu, 'fk__navigation--fixed': _vm.fixedMenu
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('svg', {
    staticClass: "fk__navigation__logo",
    staticStyle: {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "stroke-linejoin": "round",
      "stroke-miterlimit": "1.41421"
    },
    attrs: {
      "width": "100%",
      "height": "100%",
      "viewBox": "0 0 378 79",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "xml:space": "preserve"
    }
  }, [_c('title', [_vm._v("Famous King")]), _vm._v(" "), _c('rect', {
    staticStyle: {
      "fill": "none"
    },
    attrs: {
      "id": "Artboard1",
      "x": "0",
      "y": "0",
      "width": "377.108",
      "height": "78.666"
    }
  }), _vm._v(" "), _c('clipPath', {
    attrs: {
      "id": "_clip1"
    }
  }, [_c('rect', {
    attrs: {
      "id": "Artboard11",
      "x": "0",
      "y": "0",
      "width": "377.108",
      "height": "78.666"
    }
  })]), _vm._v(" "), _c('g', {
    attrs: {
      "clip-path": "url(#_clip1)"
    }
  }, [_c('g', {
    attrs: {
      "transform": "matrix(1,0,0,1,10,10)"
    }
  }, [_c('path', {
    staticClass: "fk__navigation__logo__letter",
    staticStyle: {
      "fill-rule": "nonzero"
    },
    attrs: {
      "d": "M181.684,18.804L181.684,20.7L173.428,20.7L173.428,26.712L180.484,26.712L180.484,28.608L173.428,28.608L173.428,36L171.088,36L171.088,18.804L181.684,18.804Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "fk__navigation__logo__letter",
    staticStyle: {
      "fill-rule": "nonzero"
    },
    attrs: {
      "d": "M199.836,36L198.036,36C197.828,36 197.66,35.948 197.532,35.844C197.404,35.74 197.308,35.608 197.244,35.448L195.636,31.296L187.92,31.296L186.312,35.448C186.256,35.592 186.16,35.72 186.024,35.832C185.888,35.944 185.72,36 185.52,36L183.72,36L190.596,18.804L192.96,18.804L199.836,36ZM188.568,29.616L194.988,29.616L192.288,22.62C192.112,22.188 191.94,21.648 191.772,21C191.684,21.328 191.598,21.63 191.514,21.906C191.43,22.182 191.348,22.424 191.268,22.632L188.568,29.616Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "fk__navigation__logo__letter",
    staticStyle: {
      "fill-rule": "nonzero"
    },
    attrs: {
      "d": "M213.068,29.784C213.18,29.976 213.278,30.178 213.362,30.39C213.446,30.602 213.528,30.816 213.608,31.032C213.688,30.808 213.772,30.594 213.86,30.39C213.948,30.186 214.048,29.98 214.16,29.772L219.98,19.2C220.084,19.016 220.192,18.904 220.304,18.864C220.416,18.824 220.576,18.804 220.784,18.804L222.5,18.804L222.5,36L220.46,36L220.46,23.364C220.46,23.196 220.464,23.016 220.472,22.824C220.48,22.632 220.492,22.436 220.508,22.236L214.616,32.988C214.416,33.348 214.136,33.528 213.776,33.528L213.44,33.528C213.08,33.528 212.8,33.348 212.6,32.988L206.576,22.2C206.6,22.408 206.618,22.612 206.63,22.812C206.642,23.012 206.648,23.196 206.648,23.364L206.648,36L204.608,36L204.608,18.804L206.324,18.804C206.532,18.804 206.692,18.824 206.804,18.864C206.916,18.904 207.024,19.016 207.128,19.2L213.068,29.784Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "fk__navigation__logo__letter",
    staticStyle: {
      "fill-rule": "nonzero"
    },
    attrs: {
      "d": "M245.26,27.408C245.26,28.696 245.056,29.878 244.648,30.954C244.24,32.03 243.664,32.956 242.92,33.732C242.176,34.508 241.282,35.11 240.238,35.538C239.194,35.966 238.04,36.18 236.776,36.18C235.512,36.18 234.36,35.966 233.32,35.538C232.28,35.11 231.388,34.508 230.644,33.732C229.9,32.956 229.324,32.03 228.916,30.954C228.508,29.878 228.304,28.696 228.304,27.408C228.304,26.12 228.508,24.938 228.916,23.862C229.324,22.786 229.9,21.858 230.644,21.078C231.388,20.298 232.28,19.692 233.32,19.26C234.36,18.828 235.512,18.612 236.776,18.612C238.04,18.612 239.194,18.828 240.238,19.26C241.282,19.692 242.176,20.298 242.92,21.078C243.664,21.858 244.24,22.786 244.648,23.862C245.056,24.938 245.26,26.12 245.26,27.408ZM242.872,27.408C242.872,26.352 242.728,25.404 242.44,24.564C242.152,23.724 241.744,23.014 241.216,22.434C240.688,21.854 240.048,21.408 239.296,21.096C238.544,20.784 237.704,20.628 236.776,20.628C235.856,20.628 235.02,20.784 234.268,21.096C233.516,21.408 232.874,21.854 232.342,22.434C231.81,23.014 231.4,23.724 231.112,24.564C230.824,25.404 230.68,26.352 230.68,27.408C230.68,28.464 230.824,29.41 231.112,30.246C231.4,31.082 231.81,31.79 232.342,32.37C232.874,32.95 233.516,33.394 234.268,33.702C235.02,34.01 235.856,34.164 236.776,34.164C237.704,34.164 238.544,34.01 239.296,33.702C240.048,33.394 240.688,32.95 241.216,32.37C241.744,31.79 242.152,31.082 242.44,30.246C242.728,29.41 242.872,28.464 242.872,27.408Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "fk__navigation__logo__letter",
    staticStyle: {
      "fill-rule": "nonzero"
    },
    attrs: {
      "d": "M257.624,34.152C258.336,34.152 258.972,34.032 259.532,33.792C260.092,33.552 260.566,33.216 260.954,32.784C261.342,32.352 261.638,31.836 261.842,31.236C262.046,30.636 262.148,29.976 262.148,29.256L262.148,18.804L264.464,18.804L264.464,29.256C264.464,30.248 264.306,31.168 263.99,32.016C263.674,32.864 263.222,33.598 262.634,34.218C262.046,34.838 261.328,35.324 260.48,35.676C259.632,36.028 258.68,36.204 257.624,36.204C256.568,36.204 255.616,36.028 254.768,35.676C253.92,35.324 253.2,34.838 252.608,34.218C252.016,33.598 251.562,32.864 251.246,32.016C250.93,31.168 250.772,30.248 250.772,29.256L250.772,18.804L253.088,18.804L253.088,29.244C253.088,29.964 253.19,30.624 253.394,31.224C253.598,31.824 253.894,32.34 254.282,32.772C254.67,33.204 255.146,33.542 255.71,33.786C256.274,34.03 256.912,34.152 257.624,34.152Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "fk__navigation__logo__letter",
    staticStyle: {
      "fill-rule": "nonzero"
    },
    attrs: {
      "d": "M279.868,21.492C279.796,21.612 279.72,21.702 279.64,21.762C279.56,21.822 279.456,21.852 279.328,21.852C279.192,21.852 279.034,21.784 278.854,21.648C278.674,21.512 278.446,21.362 278.17,21.198C277.894,21.034 277.562,20.884 277.174,20.748C276.786,20.612 276.316,20.544 275.764,20.544C275.244,20.544 274.784,20.614 274.384,20.754C273.984,20.894 273.65,21.084 273.382,21.324C273.114,21.564 272.912,21.846 272.776,22.17C272.64,22.494 272.572,22.844 272.572,23.22C272.572,23.7 272.69,24.098 272.926,24.414C273.162,24.73 273.474,25 273.862,25.224C274.25,25.448 274.69,25.642 275.182,25.806C275.674,25.97 276.178,26.14 276.694,26.316C277.21,26.492 277.714,26.69 278.206,26.91C278.698,27.13 279.138,27.408 279.526,27.744C279.914,28.08 280.226,28.492 280.462,28.98C280.698,29.468 280.816,30.068 280.816,30.78C280.816,31.532 280.688,32.238 280.432,32.898C280.176,33.558 279.802,34.132 279.31,34.62C278.818,35.108 278.214,35.492 277.498,35.772C276.782,36.052 275.968,36.192 275.056,36.192C273.944,36.192 272.93,35.99 272.014,35.586C271.098,35.182 270.316,34.636 269.668,33.948L270.34,32.844C270.404,32.756 270.482,32.682 270.574,32.622C270.666,32.562 270.768,32.532 270.88,32.532C271.048,32.532 271.24,32.622 271.456,32.802C271.672,32.982 271.942,33.18 272.266,33.396C272.59,33.612 272.982,33.81 273.442,33.99C273.902,34.17 274.464,34.26 275.128,34.26C275.68,34.26 276.172,34.184 276.604,34.032C277.036,33.88 277.402,33.666 277.702,33.39C278.002,33.114 278.232,32.784 278.392,32.4C278.552,32.016 278.632,31.588 278.632,31.116C278.632,30.596 278.514,30.17 278.278,29.838C278.042,29.506 277.732,29.228 277.348,29.004C276.964,28.78 276.526,28.59 276.034,28.434C275.542,28.278 275.038,28.118 274.522,27.954C274.006,27.79 273.502,27.6 273.01,27.384C272.518,27.168 272.08,26.888 271.696,26.544C271.312,26.2 271.002,25.77 270.766,25.254C270.53,24.738 270.412,24.1 270.412,23.34C270.412,22.732 270.53,22.144 270.766,21.576C271.002,21.008 271.344,20.504 271.792,20.064C272.24,19.624 272.794,19.272 273.454,19.008C274.114,18.744 274.872,18.612 275.728,18.612C276.688,18.612 277.564,18.764 278.356,19.068C279.148,19.372 279.84,19.812 280.432,20.388L279.868,21.492Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "fk__navigation__logo__letter",
    staticStyle: {
      "fill-rule": "nonzero"
    },
    attrs: {
      "d": "M296.068,26.34L296.944,26.34C297.248,26.34 297.49,26.302 297.67,26.226C297.85,26.15 298.02,26.02 298.18,25.836L303.904,19.356C304.08,19.156 304.25,19.014 304.414,18.93C304.578,18.846 304.788,18.804 305.044,18.804L307.024,18.804L300.472,26.208C300.304,26.392 300.146,26.548 299.998,26.676C299.85,26.804 299.692,26.908 299.524,26.988C299.748,27.06 299.944,27.168 300.112,27.312C300.28,27.456 300.456,27.636 300.64,27.852L307.48,36L305.464,36C305.312,36 305.184,35.988 305.08,35.964C304.976,35.94 304.886,35.908 304.81,35.868C304.734,35.828 304.664,35.776 304.6,35.712C304.536,35.648 304.472,35.58 304.408,35.508L298.468,28.68C298.38,28.584 298.298,28.502 298.222,28.434C298.146,28.366 298.058,28.308 297.958,28.26C297.858,28.212 297.742,28.178 297.61,28.158C297.478,28.138 297.316,28.128 297.124,28.128L296.068,28.128L296.068,36L293.752,36L293.752,18.804L296.068,18.804L296.068,26.34Z"
    }
  }), _vm._v(" "), _c('rect', {
    staticClass: "fk__navigation__logo__letter",
    staticStyle: {
      "fill-rule": "nonzero"
    },
    attrs: {
      "x": "312.888",
      "y": "18.804",
      "width": "2.328",
      "height": "17.196"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "fk__navigation__logo__letter",
    staticStyle: {
      "fill-rule": "nonzero"
    },
    attrs: {
      "d": "M323.624,18.804C323.832,18.804 323.986,18.83 324.086,18.882C324.186,18.934 324.3,19.04 324.428,19.2L334.388,32.16C334.364,31.952 334.348,31.75 334.34,31.554C334.332,31.358 334.328,31.168 334.328,30.984L334.328,18.804L336.368,18.804L336.368,36L335.192,36C335.008,36 334.854,35.968 334.73,35.904C334.606,35.84 334.484,35.732 334.364,35.58L324.416,22.632C324.432,22.832 324.444,23.028 324.452,23.22C324.46,23.412 324.464,23.588 324.464,23.748L324.464,36L322.424,36L322.424,18.804L323.624,18.804Z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "fk__navigation__logo__letter",
    staticStyle: {
      "fill-rule": "nonzero"
    },
    attrs: {
      "d": "M350.736,34.308C351.2,34.308 351.626,34.286 352.014,34.242C352.402,34.198 352.768,34.132 353.112,34.044C353.456,33.956 353.78,33.85 354.084,33.726C354.388,33.602 354.692,33.46 354.996,33.3L354.996,29.508L352.332,29.508C352.18,29.508 352.058,29.464 351.966,29.376C351.874,29.288 351.828,29.18 351.828,29.052L351.828,27.732L357.108,27.732L357.108,34.332C356.676,34.644 356.226,34.916 355.758,35.148C355.29,35.38 354.79,35.574 354.258,35.73C353.726,35.886 353.156,36.002 352.548,36.078C351.94,36.154 351.28,36.192 350.568,36.192C349.32,36.192 348.176,35.978 347.136,35.55C346.096,35.122 345.2,34.522 344.448,33.75C343.696,32.978 343.11,32.052 342.69,30.972C342.27,29.892 342.06,28.704 342.06,27.408C342.06,26.096 342.266,24.9 342.678,23.82C343.09,22.74 343.678,21.814 344.442,21.042C345.206,20.27 346.13,19.672 347.214,19.248C348.298,18.824 349.512,18.612 350.856,18.612C351.536,18.612 352.168,18.662 352.752,18.762C353.336,18.862 353.878,19.006 354.378,19.194C354.878,19.382 355.34,19.61 355.764,19.878C356.188,20.146 356.584,20.448 356.952,20.784L356.292,21.84C356.156,22.056 355.98,22.164 355.764,22.164C355.636,22.164 355.496,22.12 355.344,22.032C355.144,21.92 354.92,21.784 354.672,21.624C354.424,21.464 354.122,21.31 353.766,21.162C353.41,21.014 352.99,20.888 352.506,20.784C352.022,20.68 351.448,20.628 350.784,20.628C349.816,20.628 348.94,20.786 348.156,21.102C347.372,21.418 346.704,21.87 346.152,22.458C345.6,23.046 345.176,23.758 344.88,24.594C344.584,25.43 344.436,26.368 344.436,27.408C344.436,28.496 344.59,29.466 344.898,30.318C345.206,31.17 345.64,31.892 346.2,32.484C346.76,33.076 347.424,33.528 348.192,33.84C348.96,34.152 349.808,34.308 350.736,34.308Z"
    }
  })]), _vm._v(" "), _c('g', {
    attrs: {
      "transform": "matrix(1,0,0,1,10,10)"
    }
  }, [_c('clipPath', {
    attrs: {
      "id": "_clip2"
    }
  }, [_c('path', {
    attrs: {
      "d": "M92.535,40.552C88.893,44.204 84.038,46.235 78.866,46.27L78.765,46.27C76.235,46.27 73.907,45.64 71.859,44.725L71.768,42.353L71.666,39.675L69.41,41.103L67.623,42.234C64.817,40.171 63.115,38.055 62.979,37.882L52.598,24.708L53.432,22.397L54.341,19.877L51.716,20.346L49.477,20.745L44.395,14.296L44.376,14.311L43.298,12.919C40.309,9.015 36.276,6.252 31.742,4.9L30.901,2.568L29.993,0.048L28.276,2.099L26.682,4.003C26.204,3.973 25.723,3.957 25.24,3.957C16.691,3.957 9.229,8.717 5.334,15.739L2.834,15.983L0.181,16.243L1.731,18.423L3.282,20.604L3.413,20.313C2.797,22.386 2.465,24.581 2.465,26.854C2.465,33.343 5.164,39.209 9.493,43.38L9.161,45.96L8.82,48.618L11.28,47.586L13.686,46.578C17.075,48.592 21.025,49.75 25.24,49.75C29.58,49.75 33.803,48.513 37.453,46.171C37.939,45.859 38.411,45.528 38.87,45.182L41.28,45.932L43.827,46.725L43.237,44.111L42.665,41.578C43.632,40.422 44.489,39.172 45.216,37.84L42.848,34.834C40.286,40.553 35.113,44.674 29.013,45.894L27.567,43.897L25.998,41.73L24.916,44.179L24.012,46.226C16.692,45.762 10.47,41.181 7.609,34.764L9.239,33.053L11.082,31.117L8.493,30.48L6.168,29.909C6.011,28.913 5.927,27.893 5.927,26.854C5.927,20.363 9.114,14.611 13.994,11.084L16.202,12.365L18.511,13.705L18.511,11.025L18.511,8.656C20.607,7.87 22.874,7.438 25.24,7.438C29.827,7.438 34.196,9.076 37.632,11.971L36.955,13.847L36.047,16.367L38.671,15.898L40.897,15.501C40.986,15.624 41.074,15.748 41.16,15.874L48.324,24.966L48.331,24.897L54.857,33.18L53.982,35.221L52.926,37.683L55.574,37.371L57.94,37.093L60.25,40.025C60.565,40.43 67.947,49.751 78.764,49.751L78.884,49.75C79.251,49.748 79.616,49.736 79.98,49.717L81.672,51.652L83.431,53.666L84.286,51.127L85.044,48.877C88.769,47.82 92.179,45.826 94.98,43.016C95.054,42.943 95.127,42.868 95.2,42.793L93.029,40.038C92.867,40.213 92.703,40.384 92.535,40.552Z"
    }
  })]), _vm._v(" "), _c('g', {
    attrs: {
      "clip-path": "url(#_clip2)"
    }
  }, [_c('rect', {
    staticStyle: {
      "fill": "rgb(244,205,28)",
      "fill-rule": "nonzero"
    },
    attrs: {
      "x": "-4.819",
      "y": "-4.952",
      "width": "105.019",
      "height": "63.618"
    }
  })]), _vm._v(" "), _c('clipPath', {
    attrs: {
      "id": "_clip3"
    }
  }, [_c('path', {
    attrs: {
      "d": "M149.965,37.58L148.413,35.4L146.864,33.219L146.733,33.51C147.349,31.437 147.681,29.242 147.681,26.97C147.681,20.481 144.983,14.614 140.653,10.444L140.985,7.863L141.327,5.205L138.866,6.237L136.46,7.246C133.069,5.231 129.121,4.073 124.906,4.073C120.566,4.073 116.342,5.311 112.693,7.652C112.206,7.964 111.735,8.296 111.275,8.642L108.865,7.891L106.319,7.099L106.909,9.712L107.481,12.245C106.513,13.401 105.657,14.652 104.929,15.984L107.297,18.989C109.86,13.271 115.033,9.149 121.132,7.93L122.578,9.927L124.147,12.094L125.23,9.644L126.134,7.597C133.453,8.061 139.676,12.642 142.537,19.059L140.906,20.77L139.064,22.706L141.653,23.343L143.978,23.915C144.134,24.91 144.218,25.93 144.218,26.97C144.218,33.46 141.032,39.212 136.151,42.74L133.943,41.459L131.634,40.119L131.634,42.799L131.636,45.168C129.54,45.954 127.272,46.386 124.906,46.386C120.318,46.386 115.95,44.747 112.514,41.852L113.19,39.976L114.099,37.457L111.474,37.925L109.249,38.323C109.16,38.199 109.072,38.075 108.985,37.95L101.821,28.857L101.814,28.926L95.288,20.643L96.164,18.602L97.22,16.141L94.572,16.452L92.205,16.73L89.896,13.799C89.58,13.394 82.199,4.073 71.382,4.073L71.262,4.073C70.856,4.076 70.452,4.09 70.05,4.113L68.529,2.237L66.845,0.159L65.897,2.664L65.025,4.969C61.33,6.032 57.948,8.017 55.165,10.807C55.092,10.881 55.019,10.955 54.946,11.03L57.116,13.786C57.278,13.611 57.443,13.439 57.61,13.272C61.253,9.619 66.107,7.589 71.28,7.554L71.38,7.554C73.91,7.554 76.239,8.184 78.287,9.098L78.377,11.471L78.48,14.149L80.736,12.721L82.522,11.589C85.329,13.653 87.031,15.769 87.167,15.941L97.547,29.116L96.714,31.427L95.805,33.946L98.43,33.478L100.669,33.078L105.751,39.527L105.77,39.512L106.848,40.904C109.837,44.809 113.87,47.572 118.404,48.923L119.245,51.256L120.153,53.776L121.869,51.725L123.464,49.82C123.942,49.85 124.423,49.867 124.906,49.867C133.455,49.867 140.916,45.106 144.812,38.084L147.312,37.84L149.965,37.58Z"
    }
  })]), _vm._v(" "), _c('g', {
    attrs: {
      "clip-path": "url(#_clip3)"
    }
  }, [_c('rect', {
    staticStyle: {
      "fill": "rgb(244,205,28)",
      "fill-rule": "nonzero"
    },
    attrs: {
      "x": "49.946",
      "y": "-4.841",
      "width": "105.02",
      "height": "63.617"
    }
  })])])])])]), _vm._v(" "), _c('nav', {
    staticClass: "fk__navigation__nav",
    class: {
      'fk__navigation__nav--open': _vm.isOpen
    },
    on: {
      "click": _vm.toggleMenu
    }
  }, [_c('div', {
    staticClass: "fk__navigation__nav--first"
  }, [_vm._v(_vm._s(_vm.pageName))]), _vm._v(" "), _c('svg', {
    staticClass: "fk__navigation__nav__arrow",
    attrs: {
      "viewBox": "0 0 100 100",
      "xmlns": "http://www.w3.org/2000/svg",
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-miterlimit": "1.5"
    }
  }, [_c('path', {
    attrs: {
      "d": "M12.664 31.332L50 68.67 87.34 31.33",
      "fill": "none",
      "stroke": "#fff",
      "stroke-width": "16.38627"
    }
  })]), _vm._v(" "), _c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v("Home")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/mission"
    }
  }, [_vm._v("Mission")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/projects"
    }
  }, [_vm._v("Projects")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/donate"
    }
  }, [_vm._v("Donate")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/contact"
    }
  }, [_vm._v("Contact")])], 1)])])], 1)
},staticRenderFns: []}

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "project fk__project"
  }, [_c('div', {
    staticClass: "bg"
  }), _vm._v(" "), _c('div', {
    staticClass: "cover"
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "fk__project__bottom"
  }, [_c('h2', {
    staticClass: "fk__heading fk__heading--dark fk__project__bottom__heading"
  }, [_vm._v("Videos")]), _vm._v(" "), _c('div', {
    staticClass: "fk__project__video-container"
  }, _vm._l((_vm.videos), function(video) {
    return _c('div', {
      staticClass: "fk__project__video"
    }, [_c('div', {
      staticClass: "js__fitvids"
    }, [_c('iframe', {
      attrs: {
        "src": video.link + '?title=0&byline=0&portrait=0',
        "frameborder": "0",
        "rameborder": "0",
        "webkitallowfullscreen": "",
        "mozallowfullscreen": "",
        "allowfullscreen": ""
      }
    })]), _vm._v(" "), _c('p', {
      staticClass: "fk__project__video__title"
    }, [_vm._v(_vm._s(video.name))])])
  }))]), _vm._v(" "), _vm._m(1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fk__project__top"
  }, [_c('div', {
    staticClass: "fk__project__top__image"
  }, [_c('img', {
    staticClass: "fk__project__top__image__img",
    attrs: {
      "src": __webpack_require__(8)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "fk__project__top__info"
  }, [_c('div', {
    staticClass: "fk__project__top__info__container"
  }, [_c('h2', {
    staticClass: "fk__project__top__info__title"
  }, [_vm._v("Velvet Ashes")]), _vm._v(" "), _c('p', {
    staticClass: "fk__project__top__info__year"
  }, [_vm._v("2016-2017")]), _vm._v(" "), _c('p', {
    staticClass: "fk__project__top__info__details"
  }, [_vm._v("Promotional - Retreat Content")]), _vm._v(" "), _c('div', {
    staticClass: "fk__project__top__info__description"
  }, [_c('p', [_vm._v("Velvet Ashes is an online community of women serving overseas. They exist to connect the hearts of women who are separated by geography but bound together by the life of serving overseas.  It’s a place where we can link arms with one another and grab hold of the promise of Him who said, “I will give you a full life in the {seemingly} emptiest of places.” (Isaiah 58:11)")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fk__project__testimonial"
  }, [_c('div', {
    staticClass: "fk__project__testimonial__person"
  }, [_c('div', {
    staticClass: "fk__project__testimonial__person__info"
  }, [_c('img', {
    staticClass: "fk__project__testimonial__person__info--photo",
    attrs: {
      "src": __webpack_require__(51)
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "fk__project__testimonial__person__info--name"
  }, [_vm._v("Danielle Wheeler")]), _vm._v(" "), _c('h3', {
    staticClass: "fk__project__testimonial__person__info--title"
  }, [_vm._v("Founder of Velvet Ashes")])])]), _vm._v(" "), _c('div', {
    staticClass: "fk__project__testimonial__quote"
  }, [_c('h3', {
    staticClass: "fk__project__testimonial__quote__heading"
  }, [_vm._v("Client Testimonial")]), _vm._v(" "), _c('p', {
    staticClass: "fk__project__testimonial__quote__copy"
  }, [_vm._v("With the help of Famous King, our ministry created an online retreat experience that touched over 1,000 women who are serving Jesus in 91 countries. These women received encouragement, community and renewal through the videos of this retreat experience, and were empowered for the kingdom work that God has called them to. Women described the retreat as an anchor for their souls, and are eagerly awaiting the next retreat!\n      "), _c('br'), _c('br'), _vm._v("Famous King’s videography has taken our ministry to a whole new level. With high quality videos, our network and support base has multiplied. The videographer is amazing to work with. He’s extremely talented at what he does and has huge heart to help our ministry. He enabled us to communicate our message in an artistic, professional way that people find deeply moving. We are constantly asked, “Wow, who does your videos?”")])])])
}]}

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contact fk__contact"
  }, [_c('div', {
    staticClass: "fk__contact__bg"
  }), _vm._v(" "), _c('div', {
    staticClass: "fk__contact__box"
  }, [_c('h2', {
    staticClass: "fk__heading fk__heading--light fk__contact__heading"
  }, [_vm._v("Contact")]), _vm._v(" "), _c('p', {
    staticClass: "fk__contact__box__copy"
  }, [_vm._v("\n      Famous King Inc."), _c('br'), _vm._v("\n      P.O. Box 4682"), _c('br'), _vm._v("\n      Olathe, KS 66063\n    ")]), _vm._v(" "), _c('ul', {
    staticClass: "fk__contact__social"
  }, [_c('li', {
    staticClass: "fk__contact__social__icon"
  }, [_c('a', {
    attrs: {
      "href": "https://www.facebook.com/famouskingmedia"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(52)
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "fk__contact__social__icon"
  }, [_c('a', {
    attrs: {
      "href": "https://www.instagram.com/famouskingmedia"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(53)
    }
  })])]), _vm._v(" "), _c('li', {
    staticClass: "fk__contact__social__icon"
  }, [_c('a', {
    attrs: {
      "href": "https://twitter.com/famouskingmedia"
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(54)
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "fk__contact__box fk__contact__box--white"
  }, [_c('form', {
    staticClass: "fk__contact__form",
    attrs: {
      "id": "ajax-contact",
      "method": "post",
      "action": "http://famousking.com/email.php"
    }
  }, [_c('input', {
    staticClass: "fk__contact__form__input",
    attrs: {
      "id": "name",
      "name": "name",
      "type": "text",
      "autocomplete": "off",
      "required": "",
      "placeholder": "Name / Organization"
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "fk__contact__form__input",
    attrs: {
      "id": "email",
      "name": "email",
      "type": "email",
      "autocomplete": "off",
      "required": "",
      "placeholder": "Email Address"
    }
  }), _vm._v(" "), _c('textarea', {
    staticClass: "fk__contact__form__textarea",
    attrs: {
      "id": "message",
      "name": "message",
      "autocomplete": "off",
      "required": "",
      "placeholder": "Type your message here..."
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "fk__contact__form__button",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Send Email")])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "form-messages"
    }
  })])])
}]}

/***/ }),
/* 78 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "landing fk__landing"
  }, [_c('div', {
    staticClass: "fk__landing__bg"
  }), _vm._v(" "), _c('div', {
    staticClass: "fk__landing__container"
  }, [_c('h1', {
    staticClass: "fk__landing__heading"
  }, [_vm._v(_vm._s(_vm.heading))]), _vm._v(" "), _c('p', {
    staticClass: "fk__landing__copy"
  }, [_vm._v(_vm._s(_vm.copy))]), _vm._v(" "), _c('router-link', {
    staticClass: "fk__landing__cta",
    attrs: {
      "to": "/projects"
    }
  }, [_vm._v(_vm._s(_vm.cta))]), _vm._v(" "), _c('svg', {
    staticClass: "fk__landing__play",
    attrs: {
      "viewBox": "0 0 100 100",
      "xmlns": "http://www.w3.org/2000/svg",
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "stroke-linejoin": "round",
      "stroke-miterlimit": "1.414"
    }
  }, [_c('g', {
    attrs: {
      "transform": "translate(5.087 5.087)"
    }
  }, [_c('clipPath', {
    attrs: {
      "id": "a"
    }
  }, [_c('path', {
    attrs: {
      "d": "M44.956 89.913c24.83 0 44.957-20.128 44.957-44.957C89.913 20.128 69.785 0 44.956 0 20.128 0 0 20.128 0 44.956c0 24.83 20.128 44.957 44.956 44.957z"
    }
  })]), _c('g', {
    attrs: {
      "clip-path": "url(#a)"
    }
  }, [_c('path', {
    staticClass: "fk__landing__play--circle",
    attrs: {
      "fill": "#fff",
      "fill-rule": "nonzero",
      "d": "M-5-5h99.913v99.913H-5z"
    }
  })])]), _c('g', {
    attrs: {
      "transform": "translate(5.087 5.087)"
    }
  }, [_c('clipPath', {
    attrs: {
      "id": "b"
    }
  }, [_c('path', {
    attrs: {
      "d": "M61.907 46.43L36.85 58.96V33.9L61.907 46.43z"
    }
  })]), _c('g', {
    attrs: {
      "clip-path": "url(#b)"
    }
  }, [_c('path', {
    attrs: {
      "fill": "#5B4B49",
      "fill-rule": "nonzero",
      "d": "M31.85 28.902h35.058V63.96H31.85z"
    }
  })])])])], 1)])
},staticRenderFns: []}

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "project fk__project"
  }, [_c('div', {
    staticClass: "bg"
  }), _vm._v(" "), _c('div', {
    staticClass: "cover"
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "fk__project__bottom"
  }, [_c('h2', {
    staticClass: "fk__heading fk__heading--dark fk__project__bottom__heading"
  }, [_vm._v("Videos")]), _vm._v(" "), _c('div', {
    staticClass: "fk__project__video-container"
  }, _vm._l((_vm.videos), function(video) {
    return _c('div', {
      staticClass: "fk__project__video"
    }, [_c('div', {
      staticClass: "js__fitvids"
    }, [_c('iframe', {
      attrs: {
        "src": video.link + '?title=0&byline=0&portrait=0',
        "frameborder": "0",
        "rameborder": "0",
        "webkitallowfullscreen": "",
        "mozallowfullscreen": "",
        "allowfullscreen": ""
      }
    })]), _vm._v(" "), _c('p', {
      staticClass: "fk__project__video__title"
    }, [_vm._v(_vm._s(video.name))]), _vm._v(" "), (video.credit) ? _c('p', {
      staticClass: "fk__project__video__credit"
    }, [_vm._v(_vm._s(video.credit))]) : _vm._e()])
  }))]), _vm._v(" "), _vm._m(1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fk__project__top"
  }, [_c('div', {
    staticClass: "fk__project__top__image"
  }, [_c('img', {
    staticClass: "fk__project__top__image__img",
    attrs: {
      "src": __webpack_require__(46)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "fk__project__top__info"
  }, [_c('div', {
    staticClass: "fk__project__top__info__container"
  }, [_c('h2', {
    staticClass: "fk__project__top__info__title"
  }, [_vm._v("Flying Treasure")]), _vm._v(" "), _c('p', {
    staticClass: "fk__project__top__info__year"
  }, [_vm._v("2014-2017")]), _vm._v(" "), _c('p', {
    staticClass: "fk__project__top__info__details"
  }, [_vm._v("Promotional/Mini-Documentary")]), _vm._v(" "), _c('div', {
    staticClass: "fk__project__top__info__description"
  }, [_c('p', [_vm._v("Flying Treasure is a for profit company owned by Derek Hammeke, the creative lead of Famous King.  Derek has been working for many years doing various video production projects for his company.  Many of these projects are ministry based projects where he works with churches, para-church organizations and other non-profits that are pursuing to make Jesus famous.")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fk__project__testimonial"
  }, [_c('div', {
    staticClass: "fk__project__testimonial__person"
  }, [_c('div', {
    staticClass: "fk__project__testimonial__person__info"
  }, [_c('img', {
    staticClass: "fk__project__testimonial__person__info--photo",
    attrs: {
      "src": __webpack_require__(48)
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "fk__project__testimonial__person__info--name"
  }, [_vm._v("MD Neely")]), _vm._v(" "), _c('h3', {
    staticClass: "fk__project__testimonial__person__info--title"
  }, [_vm._v("CIY Video Director")])])]), _vm._v(" "), _c('div', {
    staticClass: "fk__project__testimonial__quote"
  }, [_c('h3', {
    staticClass: "fk__project__testimonial__quote__heading"
  }, [_vm._v("Client Testimonial")]), _vm._v(" "), _c('p', {
    staticClass: "fk__project__testimonial__quote__copy"
  }, [_vm._v("Derek's understanding of the language of cinema and his efficiency as an editor and cinematographer are excellent. He is a problem solver and works with a positive, team oriented attitude. Derek has become a trusted collaborator. As a cinematographer, he understands visual storytelling and emotion. On our most challenging projects he is my first choice as editor. I highly recommend him.")])])])
}]}

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "project fk__project"
  }, [_c('div', {
    staticClass: "bg"
  }), _vm._v(" "), _c('div', {
    staticClass: "cover"
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "fk__project__bottom"
  }, [_c('h2', {
    staticClass: "fk__heading fk__heading--dark fk__project__bottom__heading"
  }, [_vm._v("Videos")]), _vm._v(" "), _c('div', {
    staticClass: "fk__project__video-container"
  }, _vm._l((_vm.videos), function(video) {
    return _c('div', {
      staticClass: "fk__project__video"
    }, [_c('div', {
      staticClass: "js__fitvids"
    }, [_c('iframe', {
      attrs: {
        "src": video.link + '?title=0&byline=0&portrait=0',
        "frameborder": "0",
        "rameborder": "0",
        "webkitallowfullscreen": "",
        "mozallowfullscreen": "",
        "allowfullscreen": ""
      }
    })]), _vm._v(" "), _c('p', {
      staticClass: "fk__project__video__title"
    }, [_vm._v(_vm._s(video.name))])])
  }))]), _vm._v(" "), _vm._m(1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fk__project__top"
  }, [_c('div', {
    staticClass: "fk__project__top__image"
  }, [_c('img', {
    staticClass: "fk__project__top__image__img",
    attrs: {
      "src": __webpack_require__(6)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "fk__project__top__info"
  }, [_c('div', {
    staticClass: "fk__project__top__info__container"
  }, [_c('h2', {
    staticClass: "fk__project__top__info__title"
  }, [_vm._v("Honduras Ministries")]), _vm._v(" "), _c('p', {
    staticClass: "fk__project__top__info__year"
  }, [_vm._v("2016")]), _vm._v(" "), _c('p', {
    staticClass: "fk__project__top__info__details"
  }, [_vm._v("Promotional/Mini-Documentary")]), _vm._v(" "), _c('div', {
    staticClass: "fk__project__top__info__description"
  }, [_c('p', [_vm._v("Honduras Ministries exists to nurture the spiritual and physical needs of the people of Honduras through education, a unique child enrichment program, and rural community development. They operate in the ultra-poor communities throughout rural Honduras; communities that are forgotten, ignored, and abandoned by their government. The people of these communities live on less than $1.50 a day and are among the most impoverished people in the world. Honduras currently ranks as the fourth poorest country in the western hemisphere. Starvation, death from disease, and human trafficking are just some of the realities the people in these communities deal with on a daily basis. Honduras Ministries believes that through their partnership with the local church, they can make a difference.")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fk__project__testimonial"
  }, [_c('div', {
    staticClass: "fk__project__testimonial__person"
  }, [_c('div', {
    staticClass: "fk__project__testimonial__person__info"
  }, [_c('img', {
    staticClass: "fk__project__testimonial__person__info--photo",
    attrs: {
      "src": __webpack_require__(49)
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "fk__project__testimonial__person__info--name"
  }, [_vm._v("John Beddall")]), _vm._v(" "), _c('h3', {
    staticClass: "fk__project__testimonial__person__info--title"
  }, [_vm._v("Honduras Ministries")])])]), _vm._v(" "), _c('div', {
    staticClass: "fk__project__testimonial__quote"
  }, [_c('h3', {
    staticClass: "fk__project__testimonial__quote__heading"
  }, [_vm._v("Client Testimonial")]), _vm._v(" "), _c('p', {
    staticClass: "fk__project__testimonial__quote__copy"
  }, [_vm._v("Working with Famous King was an amazing experience from start to finish. Derek’s creativity and passion for his art form showed in every aspect of production. Being able to work with Famous King has given our ministry a wonderful tool that has already aided us in fundraising and exposing partnering organizations to our ministry. We will, without a doubt, be working with them again soon!")])])])
}]}

/***/ }),
/* 81 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('navigation'), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "team fk__team"
  }, [_c('div', {
    staticClass: "fk__team__bg--texture"
  }), _vm._v(" "), _c('div', {
    staticClass: "fk__team__bg--orange"
  }), _vm._v(" "), _c('div', {
    staticClass: "fk__team__gradient"
  }), _vm._v(" "), _c('h2', {
    staticClass: "fk__heading fk__heading--dark fk__team__heading"
  }, [_vm._v("Our Mission")]), _vm._v(" "), _c('div', {
    staticClass: "fk__team__container"
  }, [_c('div', {
    staticClass: "fk__team__info fk__team__info--main"
  }, [_c('p', {
    staticClass: "fk__team__info__copy"
  }, [_vm._v("Famous King's mission is to share who the one true God is to the world and to help make him famous by using film and creative media.")]), _vm._v(" "), _c('p', {
    staticClass: "fk__team__info__copy"
  }, [_vm._v("Our vision is that Famous King would help engage people in making God famous through projects such as promotional videos for non-profit organizations who are actively expressing who God is through their existing work, documentaries expressing characteristics of God and how he works with his people, as well as narrative works of fiction that help express God's characteristics and truth in the lives of his people.")]), _vm._v(" "), _c('div', {
    staticClass: "fk__team__info__image-container"
  }, [_c('img', {
    staticClass: "fk__team__info__image",
    attrs: {
      "src": __webpack_require__(57)
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "fk__team__info__image",
    attrs: {
      "src": __webpack_require__(55)
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "fk__team__info__copy"
  }, [_vm._v("Famous King is committed to producing works with excellence and with a cost-effective mindset. Video production can be a costly process and can result in big budgets and with lots of expenses. Famous King is committed to using a thoughtful and prayerful process to create the most impactful products with a minimum amount of cost.")]), _vm._v(" "), _c('p', {
    staticClass: "fk__team__info__copy"
  }, [_vm._v("The Famous King team is looking for partners who are making an impact for the Kingdom. We will ambitiously team up to produce creative media that will make God famous to the nations.")])]), _vm._v(" "), _c('div', {
    staticClass: "fk__team__member"
  }, [_c('img', {
    staticClass: "fk__team__member__head",
    attrs: {
      "src": __webpack_require__(56)
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "fk__team__member__email",
    attrs: {
      "href": "mailto:kent.broddle@famousking.com"
    }
  }, [_c('img', {
    staticClass: "fk__team__member__email--icon",
    attrs: {
      "src": __webpack_require__(43)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "fk__team__member__info"
  }, [_c('h3', {
    staticClass: "fk__team__member__info--name"
  }, [_vm._v("Kent Broddle")]), _vm._v(" "), _c('p', {
    staticClass: "fk__team__member__info--position"
  }, [_vm._v("President")]), _vm._v(" "), _c('p', {
    staticClass: "fk__team__member__info--description"
  }, [_vm._v("Kent Broddle has worked at Garmin International for the last 25 years as a software engineer and engineering leader. He has been assigned to many interesting products including automotive infotainment, mobile phones, digital radios, GPS equipped PDAs, aviation navigation devices, and GPS surveying equipment. His travels have taken him to many leading cultural centers such as London, Beijing, Shanghai, Taipei, and Barcelona. Kent has been an integral part of this world-wide, world-class company and has learned valuable lessons in product development, process structure, and large team organization.")]), _vm._v(" "), _c('p', {
    staticClass: "fk__team__member__info--description"
  }, [_vm._v("\nKent’s passion for starting Famous King started while travelling internationally. During one of the long flights to-from Taipei, God provided overwhelming inspiration to startup a film company whose mission would be to make Him famous. After many conversations and much soul searching, a team began to form that shared much of this same passion. Several years later, God has guided us to this tipping point… we want to share who the one true God is to the world and to help make him famous by using film and creative media.")]), _vm._v(" "), _c('p', {
    staticClass: "fk__team__member__info--description"
  }, [_vm._v("Kent has been married to his wife, Tonya, for 30 years and have 3 grown children. Kent and Tonya have been serving at Foundry Church in Lenexa, Kansas. During his free time Kent enjoys many activities and hobbies including basketball, softball, biking, playing games, watching sports, and spending time with family and friends.")])])])])])
}]}

/***/ })
],[27]);


// WEBPACK FOOTER //
// static/js/app.4a21528a06de1f42dfc1.js